export const API_URL = process.env.REACT_APP_API_BASE || '';
export const APP_ENV = process.env.REACT_APP_ENV || 'development';
export const RSMIN_APP_URL = process.env.REACT_APP_RSMIN_APP_URL || '';
